import { Info } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import { FormLabel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { WorkFlowStatus } from '../WorkFlowCard/types';

import './WorkFlowDate.scss';

export type WorkFlowDateProps = {
  date: string | Date;
  className?: string;
  displayTag?: boolean;
  label?: React.ReactElement;
  status: WorkFlowStatus;
};

export const WorkFlowDate: React.FC<WorkFlowDateProps> = ({
  date,
  status,
  displayTag,
  label,
  className,
}) => {
  const { t } = useTranslation();
  const diff = moment().diff(moment(date), 'days');

  return (
    <div
      className={`work-flow-date d-flex flex-nowrap justify-content-between align-items-center ${
        className ?? ''
      } ${displayTag ? 'display-tag' : ''} ${diff > 0 ? 'error' : 'warning'}`}
    >
      <FormLabel className="mb-0" name={t('label_assigned_close_date')}>
        {label || `${t('label_assigned_close_date')}: `}
      </FormLabel>
      <div className="d-flex align-items-center">
        <span
          className={`date-text ${
            diff > 0 && status === WorkFlowStatus.OPEN ? 'error' : ''
          }`}
        >
          {moment(date).format('DD/MM/YYYY')}
        </span>
        <Tooltip
          arrow
          enterTouchDelay={0}
          title={
            diff > 0
              ? `${diff} days passed`
              : `${Math.abs(diff)} days remaining`
          }
          placement="top"
        >
          <Info color={diff > 0 ? 'error' : 'warning'} />
        </Tooltip>
      </div>
    </div>
  );
};
